import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';

const ArchiveGallery: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const galleryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' },
    );

    if (galleryRef.current) {
      observer.observe(galleryRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={galleryRef} className={styles.archiveGallery}>
      <div className={styles.titleContainer}>
        <h2 className={styles.title}>THANK YOU FOR COMING!</h2>
        <p className={styles.subtitle}>
          「かまた祭 2025」は無事終了しました。
          <br />
          沢山のご来校、誠にありがとうございました。
        </p>
      </div>

      {isVisible && (
        <div className={styles.scrollContainer}>
          {/* 上段：左から右へスクロール */}
          <div className={styles.scrollRow}>
            <div className={styles.scrollTrack}>
              <img src="/images/2025/slide__archive/DSC01727.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01754.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01764.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01766.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01781.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01800.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01805.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01820.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01845.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01847.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01848.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01869.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01888.webp" alt="" decoding="async" />
            </div>
            <div
              className={`${styles.scrollTrack} ${styles.scrollTrackDuplicate}`}
              aria-hidden="true"
            >
              <img src="/images/2025/slide__archive/DSC01727.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01754.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01764.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01766.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01781.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01800.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01805.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01820.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01845.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01847.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01848.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01869.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01888.webp" alt="" decoding="async" />
            </div>
          </div>

          {/* 下段：右から左へスクロール */}
          <div className={`${styles.scrollRow} ${styles.reverse}`}>
            <div className={styles.scrollTrack}>
              <img src="/images/2025/slide__archive/DSC02187.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02175.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02148.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02136.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02131.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02118.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02092.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02057.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02020.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01993.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01972.webp" alt="" decoding="async" />
            </div>
            <div
              className={`${styles.scrollTrack} ${styles.scrollTrackDuplicate}`}
              aria-hidden="true"
            >
              <img src="/images/2025/slide__archive/DSC02187.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02175.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02148.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02136.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02131.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02118.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02092.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02057.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC02020.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01993.webp" alt="" decoding="async" />
              <img src="/images/2025/slide__archive/DSC01972.webp" alt="" decoding="async" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArchiveGallery;
